import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { ChangeEvent, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Typography from "@insite/mobius/Typography";
import Select from "@insite/mobius/Select";
import TextField from "@insite/mobius/TextField";
import DatePicker, { DatePickerState } from "@insite/mobius/DatePicker";
import { FormFieldStyle, FormInputWrapper } from "@insite/mobius/FormField";
import Button from "@insite/mobius/Button";
import { IconWrapper } from "@insite/mobius/Icon";
import ADIColors from "@NA/Utils/ADIColors";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import adiRMAStatus from "@NA/Handlers/ADIRMAStatusHandler";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";

const mapStateToProps = (state: CustomApplicationState) => ({
    getRMAStatusParams: state.ADIGlobalData.ADIRMAStatusStore.loadRMAStatusParameters,
    getRMAStatusData: state.ADIGlobalData.ADIRMAStatusStore.rmaStatusResults,
});

const mapDispatchToProps = {
    adiRMAStatus,
};

type Props = WidgetProps & HasHistory & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface ReturnHistoryFilterStyles {
    rhHeader?: InjectableCss;
    rhitems?: InjectableCss;
    rhMainWrap?: InjectableCss;
    rhBody?: InjectableCss;
    formControl?: InjectableCss;
    formSelect?: InjectableCss;
    formInput?: InjectableCss;
    formRangeDate?: InjectableCss;
    formDate?: InjectableCss;
    dataRnageText?: InjectableCss;
    rhFooter?: InjectableCss;
    cancelButton?: InjectableCss;
    saveButton?: InjectableCss;
}

export const returnHistoryFilterStyles: ReturnHistoryFilterStyles = {
    rhHeader: {
        css: css`
            background: ${ADIColors.blue4};
            height: 28px;
            color: ${ADIColors.white};
            padding: 3px 5px 3px 13px;
            margin-top: 13px;
            font-size: 16px;
            font-weight: normal;
            vertical-align: middle;
        `,
    },
    rhitems: {
        css: css`
            flex-direction: column;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        max-width: 100%;
                        width: 100% !important;
                    `,
                    css`
                        max-width: 100%;
                        width: 100% !important;
                    `,
                    css`
                        max-width: 50%;
                        width: 50% !important;
                        padding-right: 30px;
                    `,
                    css`
                        max-width: 25%;
                        width: 25% !important;
                        padding-right: 30px;
                    `,
                    css`
                        max-width: 25%;
                        width: 25% !important;
                        padding-right: 30px;
                    `,
                ])}
        `,
    },
    rhBody: {
        css: css`
            padding: 13px;
            display: flex;
            flex-wrap: wrap;
            width: 100%;
            .Rhitems {
                padding-right: 0px;
            }
        `,
    },
    rhFooter: {
        css: css`
            padding: 13px;
            display: flex;
            width: 100%;
            justify-content: flex-end;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-top: 0px;
                    `,
                    css`
                        padding-top: 0px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    formControl: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        > div {
                            display: grid;
                            grid-template-columns: 35% 65%;
                            margin-bottom: 16px;
                        }
                    `,
                    css`
                        > div {
                            display: grid;
                            grid-template-columns: 35% 65%;
                            margin-bottom: 16px;
                        }
                    `,
                    null,
                    null,
                    null,
                ])}
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        ${FormInputWrapper} {
                            margin-top: 0px !important;
                        }
                    `,
                    css`
                        ${FormInputWrapper} {
                            margin-top: 0px !important;
                        }
                    `,
                    null,
                    null,
                    null,
                ])}
            > div {
                flex-wrap: wrap;
            }
            div {
                width: 100%;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        label {
                            line-height: normal;
                        }
                    `,
                    css`
                        label {
                            line-height: normal;
                        }
                    `,
                    css`
                        label {
                            line-height: 29px;
                        }
                    `,
                    css`
                        label {
                            line-height: 29px;
                        }
                    `,
                    css`
                        label {
                            line-height: 29px;
                        }
                    `,
                ])}
            label {
                display: block;
                width: 100%;
                text-align: left;
                padding: 0;
                font-size: 12px;
            }
            select {
                display: block;
                width: 100%;
                height: 29px !important;
                border-radius: 0px !important;
                padding: 0 10px !important;
            }
            select:focus {
                border-color: transparent !important;
            }
            input {
                height: 29px !important;
                border-radius: 0px !important;
                padding: 0 10px !important;
            }
            input:focus {
                border-color: transparent !important;
            }
            ${IconWrapper} {
                top: 0px !important;
                width: 29px !important;
                height: 29px !important;
            }
        `,
    },
    dataRnageText: {
        css: css`
            font-size: 12px;
            text-transform: capitalize;
            font-weight: 700;
            margin-bottom: 0px;
            text-align: left;
            padding: 0;
            line-height: 29px;
        `,
    },
    formSelect: {
        css: css`
            padding: 10px;
        `,
    },
    formInput: {
        css: css`
            padding: 10px;
        `,
    },
    formRangeDate: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: grid;
                        grid-template-columns: 1fr;
                        grid-column-gap: 15px;
                    `,
                    css`
                        display: grid;
                        grid-template-columns: 1fr;
                        grid-column-gap: 15px;
                    `,
                    css`
                        display: grid;
                        grid-template-columns: 1fr 1fr;
                        grid-column-gap: 15px;
                    `,
                    css`
                        display: grid;
                        grid-template-columns: 1fr 1fr;
                        grid-column-gap: 15px;
                    `,
                    css`
                        display: grid;
                        grid-template-columns: 1fr 1fr;
                        grid-column-gap: 15px;
                    `,
                ])}

            .react-datetime-picker {
                height: 29px !important;
                line-height: 29px !important;
                border-radius: 0px !important;
                padding: 0 10px !important;
            }
            .react-datetime-picker__calendar-button {
                display: none;
            }
            ${FormFieldStyle} {
                flex-direction: row;
                width: 100%;
                label {
                    width: unset;
                    white-space: nowrap;
                    margin: auto 0 0 0;
                    margin-right: 10px;
                    font-size: 12px;
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        ${FormFieldStyle} {
                            display: grid;
                            grid-template-columns: 35% 65%;
                            margin-bottom: 16px;
                        }
                    `,
                    css`
                        ${FormFieldStyle} {
                            display: grid;
                            grid-template-columns: 35% 65%;
                            margin-bottom: 16px;
                        }
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    formDate: {
        css: css``,
    },
    cancelButton: {
        css: css`
            border-radius: 0px;
            background: ${ADIColors.gray22};
            color: ${ADIColors.white};
            border: 1px solid ${ADIColors.gray22};
            margin-right: 15px;
            width: 97px;
            height: 28px;
            min-height: 28px;
            line-height: 28px;
            padding: 0;
            font-weight: bold;
            min-width: 100px;
            > ${TypographyStyle} {
                font-size: 14px;
            }
            :hover,
            :focus {
                background: ${ADIColors.gray22};
                color: ${ADIColors.white};
                border: 1px solid ${ADIColors.gray22};
                opacity: 0.9;
            }
        `,
    },
    saveButton: {
        css: css`
            border-radius: 0px;
            background: ${ADIColors.blueBgColorButton};
            color: ${ADIColors.white};
            border: 1px solid ${ADIColors.blueBgColorButton};
            width: 97px;
            height: 28px;
            min-height: 28px;
            line-height: 28px;
            padding: 0;
            margin: 0;
            font-weight: bold;
            min-width: 100px;
            > ${TypographyStyle} {
                font-size: 14px;
            }
            :hover,
            :focus {
                background: ${ADIColors.blueBgColorButton};
                color: ${ADIColors.white};
                border: 1px solid ${ADIColors.blueBgColorButton};
                opacity: 0.9;
            }
        `,
    },
};

const styles = returnHistoryFilterStyles;

const ReturnHistoryFilter = ({ getRMAStatusParams, getRMAStatusData, adiRMAStatus }: Props) => {
    const formatDateHandler = (date: Date): string => {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Adding 1 to month because it's zero-indexed
        const day = date.getDate().toString().padStart(2, "0");

        return `${year}/${month}/${day}`;
    };

    const today = new Date();
    const oneMonthAgo = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate() + 1);
    const [fromDate, setFromDate] = useState(oneMonthAgo);
    const [toDate, setToDate] = useState(today);
    const [searchInput, setSearchInput] = useState("");
    const [statusInput, setStatusInput] = useState("All");
    const [typeInput, setTypeInput] = useState("All");

    const changeStatusFilter = (event: React.FormEvent<HTMLSelectElement>) => {
        setStatusInput(event.currentTarget.value);
    };

    const changeTypeFilter = (event: React.FormEvent<HTMLSelectElement>) => {
        setTypeInput(event.currentTarget.value);
    };

    const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchInput(e.currentTarget.value);
    };

    const fromDateChangeHandler = ({ selectedDay }: Pick<DatePickerState, "selectedDay">) => {
        if (selectedDay) {
            setFromDate(selectedDay);
        }
    };

    const toDateChangeHandler = ({ selectedDay }: Pick<DatePickerState, "selectedDay">) => {
        if (selectedDay) {
            setToDate(selectedDay);
        }
    };

    const handlerCancelSearch = (e: React.MouseEvent<HTMLButtonElement>) => {
        const today = new Date();
        const oneMonthAgo = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate() + 1);
        e.preventDefault();
        setSearchInput("");
        setTypeInput("All");
        setStatusInput("All");
        setFromDate(oneMonthAgo);
        setToDate(today);
        adiRMAStatus({
            ...getRMAStatusParams,
            pO: "",
            orderSearchType: "All",
            status: "All",
            fromDate: formatDateHandler(oneMonthAgo),
            toDate: formatDateHandler(today),
            onSuccess() { }
        });

    };

    React.useEffect(() => {
        const handleBeforeUnload = (event: { preventDefault: () => void; returnValue: string }) => {
            event.preventDefault();
            //   event.returnValue = ''; // Some browsers require a non-empty string
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, []);

    const handlerSaveSearch = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        adiRMAStatus({
            ...getRMAStatusParams,
            pO: searchInput,
            orderSearchType: searchInput === "" || searchInput === null ? "PO" : "PONumber", // P21 Change
            status: statusInput,
            fromDate: formatDateHandler(fromDate),
            toDate: formatDateHandler(toDate),
            sortOrder: null, // This property is being used in P21
            onSuccess() { }
        });
    };
    const statusOptions = [
        { key: "All", value: "All", label: translate("All") },
        { key: "O", value: "O", label: translate("Open") },
        { key: "C", value: "C", label: translate("Closed") },
        { key: "IP", value: "TP", label: translate("In Progress") },
    ];
    const typeOptions = [
        { key: "All", value: "All", label: translate("All") },
        { key: "PONumber", value: "PONumber", label: translate("Purchase Order Number") },
    ];

    return (
        <>
            {getRMAStatusData !== null && getRMAStatusData !== undefined && (
                <StyledWrapper {...styles.rhMainWrap}>
                    <StyledWrapper {...styles.rhHeader}>
                        <Typography>{translate(`Search History`)}</Typography>
                    </StyledWrapper>
                    <StyledWrapper {...styles.rhBody}>
                        <StyledWrapper {...styles.rhitems}>
                            <StyledWrapper {...styles.formControl}>
                                <TextField
                                    {...styles.formInput}
                                    label={translate("Search")}
                                    value={searchInput}
                                    onChange={handleSearchChange}
                                />
                            </StyledWrapper>
                        </StyledWrapper>
                        {/* Below code commented by P21 ----- P21 Change            */}
                        {/* <StyledWrapper {...styles.rhitems}>
                            <StyledWrapper {...styles.formControl}>
                                <Select
                                    className="pageSize"
                                    {...styles.formSelect}
                                    label={translate("Type")}
                                    value={typeInput}
                                    labelPosition="left"
                                    onChange={changeTypeFilter}
                                    data-test-selector="returnHistoryTypeSelect"
                                >
                                    {typeOptions.map(option => (
                                        <option key={option.key} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </Select>
                            </StyledWrapper>
                        </StyledWrapper> */}
                        <StyledWrapper {...styles.rhitems}>
                            <StyledWrapper {...styles.formControl}>
                                <Select
                                    className="pageSize"
                                    {...styles.formSelect}
                                    label={translate("Status")}
                                    value={statusInput}
                                    labelPosition="left"
                                    onChange={changeStatusFilter}
                                    data-test-selector="returnHistoryStatusSelect"
                                >
                                    {statusOptions.map(option => (
                                        <option key={option.key} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </Select>
                            </StyledWrapper>
                        </StyledWrapper>
                        <StyledWrapper {...styles.rhitems} className="Rhitems">
                            <Typography variant="p" {...styles.dataRnageText}>
                                {translate(`Date Range`)}
                            </Typography>
                            <StyledWrapper {...styles.formRangeDate}>
                                <DatePicker
                                    {...styles.formDate}
                                    label={translate("From")}
                                    selectedDay={fromDate}
                                    onDayChange={fromDateChangeHandler}
                                    format="MM/dd/y"
                                    dateTimePickerProps={{
                                        clearIcon: null,
                                    }}
                                />
                                <DatePicker
                                    {...styles.formDate}
                                    label={translate("To")}
                                    selectedDay={toDate}
                                    onDayChange={toDateChangeHandler}
                                    format="MM/dd/y"
                                    dateTimePickerProps={{
                                        clearIcon: null,
                                    }}
                                />
                            </StyledWrapper>
                        </StyledWrapper>
                        <StyledWrapper {...styles.rhFooter}>
                            <Button {...styles.cancelButton} onClick={handlerCancelSearch}>
                                {translate("Clear")}
                            </Button>
                            <Button {...styles.saveButton} onClick={handlerSaveSearch}>
                                {translate("Search")}
                            </Button>
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(ReturnHistoryFilter)),
    definition: {
        group: "Basic",
        displayName: "ADI RMA Status History Filter",
    },
};

export default widgetModule;
